export const GET_ALL_ACCOUNT_START = 'GET_ALL_ACCOUNT_START'
export const GET_ALL_ACCOUNT_SUCCEED = 'GET_ALL_ACCOUNT_SUCCEED'
export const SET_SELECTED_USER_INFO = 'SET_SELECTED_USER_INFO'
export const GET_CURRENCY_RATE_SUCCEED = 'GET_CURRENCY_RATE_SUCCEED'
export const SET_CURRENCY_INFO = 'SET_CURRENCY_INFO'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
